<div class="row">
<p>searchpage works!</p>
<button class="btn btn-default" (click)="onTest()">Save</button>
</div>
